import { Navigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import ChatHeader     from '../components/chat-header';
import MessageList    from '../components/message-list';
import { useResetUnread } from '../hooks/use-reset-unread';
import MessageInput from "@/app/user/messages/components/message-input.tsx";
import TypingIndicator from "@/app/user/messages/components/typing-indicator.tsx";
import { AppointmentActionBar } from "../components/appointment-actions";
import { ChatRoomType } from "@/models/chat.model";
import { UserRole } from "../components/appointment-actions/actions";
import { organization_type } from "@/models/organization.model";
import { appointment_status } from "@/models/appointment.model";

export default function ChatRoomPage() {
    const {roomId} = useParams();

    const room = useSelector((s: RootState) =>
        s.messages.list.find(r => r.id === roomId)
    );
    
    const activeOrg = useSelector((s: RootState) => {
        const activeOrgId = s.organization.activeOrgId;
        return s.organization.organizations.find(org => org.id === activeOrgId);
    });

    useResetUnread(roomId);

    if (!room) {
        return <Navigate to="/messages" replace />;
    }

    // Check if this is an appointment group chat
    const isAppointmentChat = room.type === ChatRoomType.appointment && room.appointment_data;
    
    // Determine user role for appointment actions
    const getUserRole = (): UserRole | null => {
        if (!activeOrg) return null;
        
        switch (activeOrg.type) {
            case organization_type.pmc:
                return UserRole.PMC;
            case organization_type.vendor:
                return UserRole.VENDOR;
            case organization_type.subs:
                return UserRole.SUBS;
            default:
                return null;
        }
    };

    const userRole = getUserRole();

    return (
        <div className="flex-1 flex flex-col">
            <div className="p-4 border-b">
                <ChatHeader room={room as any} />
            </div>

            <MessageList roomId={roomId as any} />

            {roomId && <TypingIndicator roomId={roomId}/>}
            
            {/* Appointment Actions Bar - only for appointment chats */}
            {isAppointmentChat && userRole && room.appointment_data && (
                <AppointmentActionBar
                    appointmentId={room.appointment_data.id}
                    currentStatus={room.appointment_data.status as appointment_status}
                    currentDate={room.appointment_data.date}
                    userRole={userRole}
                    maxVisibleActions={3}
                    vendorId={room.appointment_data.vendor?.id}
                    serviceId={room.appointment_data.service?.id}
                    roomId={roomId}
                />
            )}
            
            <MessageInput />
        </div>
    );
}
